@if (isAddClicked) {
  <app-meter-model-setup
    (closeModal)="toggleModal($event)"
    (reload)="reloadTable(currentPage)"
    [selectedMeterModel]="selectedRowId"
  ></app-meter-model-setup>
}

<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row d-flex justify-content-between g-0 m-0">
      <div
        class="col-10 d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-3"
      >
        <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
        <app-search
          placeholder="{{
            'SETTINGS_SEARCHBYFIRMWARE&MODEL&METERMAKE' | translate
          }}"
          (searchChange)="searchChange($event)"
        ></app-search>
      </div>
      @if (
        authService.isAuthorized([
          PermissionsEnum.Settings_crud_metermodel_modify,
        ])
      ) {
        <div
          class="col-2 d-flex align-items-center justify-content-end g-0 m-0 mt-3 mb-3 me-4 add"
          (click)="toggleModal()"
        >
          <span
            >{{ "ADD" | translate }}
            {{ "DEVICESETUP_METERMODEL" | translate }}</span
          >
        </div>
      }
    </div>
    <div class="row g-0 m-0 pt-3">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "MODEL" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "FIRMWAREVERSION" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "METERMAKE" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "METERPHASE" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "CODE" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "CREATEDTIME" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "CREATEDBY" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "UPDATEDTIME" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "UPDATEDBY" | translate }}</span>
              </div>
            </th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of data; let i = index"
            (click)="
              authService.isAuthorized([
                PermissionsEnum.Settings_crud_metermodel_modify,
              ])
                ? handleRowClick(row.id!)
                : null
            "
          >
            <td></td>
            <td>
              <span
                class="copyable"
                title="{{ row.model }}"
                (click)="clipboardService.copyToClipboardDeviceManagement(row.model!, $event, 'model-' + i)"
              >{{ row.model }}
                <span class="copy-tooltip" *ngIf="clipboardService.copiedId === 'model-' + i">
                  {{ "COPIED" | translate }}
                </span>
              </span>
            </td>
            <td>
              <span
                class="copyable"
                title="{{ row.firmwareVersion }}"
                (click)="clipboardService.copyToClipboardDeviceManagement(row.firmwareVersion!, $event, 'firmware-' + i)"
              >{{ row.firmwareVersion }}
                <span class="copy-tooltip" *ngIf="clipboardService.copiedId === 'firmware-' + i">
                  {{ "COPIED" | translate }}
                </span>
              </span>
            </td>
            <td>
              <span title="{{row.meterMake}}">{{ row.meterMake }}</span>
            </td>
            <td>
              <span>{{ row.meterPhase }}</span>
            </td>
            <td>
              <span>{{ row.code }}</span>
            </td>
            <td title="{{ row.creationDate | date: 'dd MMM yyyy, h:mm a' }}">
              <span>{{ row.creationDate | date: "dd MMM yyyy, h:mm a" }}</span>
            </td>
            <td>
              <span>{{ row.createdBy ?? "-" }}</span>
            </td>
            <td title="{{ row.lastUpdateTime | date: 'dd MMM yyyy, h:mm a' }}">
              <span>{{
                (row.lastUpdateTime | date: "dd MMM yyyy, h:mm a") ?? "-"
              }}</span>
            </td>
            <td>
              <span>{{ row.updatedBy ?? "-" }}</span>
            </td>
            <td>
              @if (
                authService.isAuthorized([
                  PermissionsEnum.Settings_crud_metermodel_view,
                ])
              ) {
                <img
                  title="{{ 'EVENT_CODE_MAP' | translate }}"
                  src="assets/events-alarms/event-code-mapping.svg"
                  (click)="
                    $event.stopPropagation();
                    handleEventCodes(row)
                  "
                />
              }
            </td>
            <td>
              @if (
                authService.isAuthorized([
                  PermissionsEnum.Settings_crud_metermodel_modify,
                ])
              ) {
                <img
                  title="Edit Associations"
                  src="assets/core/table/edit-associations.svg"
                  (click)="
                    $event.stopPropagation();
                    handleEditAssociation(row)
                  "
                />
              }
            </td>
            <td>
              @if (
                authService.isAuthorized([
                  PermissionsEnum.Settings_crud_metermodel_delete,
                ])
              ) {
                <img
                  src="assets/core/table/delete.svg"
                  (click)="$event.stopPropagation(); handleDelete(row.id!)"
                />
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfMeterModels"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>

@if (isDeleteModalOpen) {
  <app-confirm-dialog titleKey="DELETE" question="METERMODEL_DELETE"
    (confirm)="confirmDelete()" (cancel)="cancelDelete()"></app-confirm-dialog>
}
